/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IConnectMessage extends IMessage {
	documentId: string;
}

export default class ConnectMessage extends Message {
	public static readonly TYPE: string = '92';

	public static readonly READABLE_TYPE_NAME: string = 'connectToComment';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2ConnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly documentId: string ) {
		super();
	}

	public toJSON(): IConnectMessage {
		return {
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IConnectMessage ): ConnectMessage {
		return new ConnectMessage( object.documentId );
	}
}
